import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import media from '@/styles/media';

interface balloon {
  fade : boolean
  text: string
  color?: string
  help?:boolean;
  size?: 'small' | 'medium' // 사이즈 추가되면 타입도 추가해서 쓰기
}
// fade가 t일떄 사라짐
export const BalloonModal = ({
  fade, text, color, help, size,
}: balloon) => {
  const [show, setShow] = useState<boolean>(true);

  useEffect(() => {
    let check: any;
    if (fade) {
      check = setTimeout(() => {
        setShow(false);
      }, 1000);
    } else {
      setShow(true);
    }

    return () => {
      clearTimeout(check);
    };
  }, [fade]);

  if (!show) return null;
  return (
    <ModalDiv>
      <Tag fade={fade} className={size}>
        <Triangle color={color} className={size} />
        {help
          ? <HelpBallon color={color}>{text}</HelpBallon>
          : <Balloon color={color} className={size}>{text}</Balloon>}
      </Tag>
    </ModalDiv>
  );
};

const ModalDiv = styled.div`
  position: relative;
`;

interface Tag{
  fade: boolean
}
/** 애니메이션을 통해 모달 자연스럽게 사라지게 구현 */
const Tag = styled.div<Tag>`
  position: absolute; 
  width: 100%;
  top: -5px;
  z-index: 1;
  display: flex;
  flex-direction:column;

  &.small{
    top: -4px;
  } 

  ${(props) => props.fade && `
    animation: smoothDisappear 1s ease-in-out 0s 1 reverse forwards;
  `}
    @keyframes smoothDisappear  {
      from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  ${media.lg`
    align-items: center;
  `}
`;

const Triangle = styled.div`
  position: relative;
  top: 5px;
  margin: auto;
  width: 10px;
  height: 10px;
  background-color: ${(props) => (props.color ? props.color : '#303031')};
  transform: rotate(-45deg);
  &.small{
    width: 7px;
    height: 8px;
  }  
`;

const Balloon = styled.div`
  background-color:${(props) => (props.color ? props.color : '#303031')};
  color:${(props) => (props.color ? '#FFFFFF' : '#EBEBEB')}; 
  padding: 12px 21px;
  margin: auto;
  font-size: 12px;
  border-radius: 8px;
  text-align: center;
  white-space: pre-wrap;

  &.small{
    padding: 10px 8px;
  } 

  ${media.lg`
    margin: 0;
    width: 300px;
    padding: 12px 0;
  `}
  ${media.xs`
    width: 290px;
  `}
`;

const HelpBallon = styled(Balloon)`
  position: relative;
  left: 91px;
`;
